import ApiClient from '../ApiClient';

class ElevenlabsVoiceChannel extends ApiClient {
  constructor() {
    super('channels/elevenlabs_voice_channel', { accountScoped: true });
  }
}

export default new ElevenlabsVoiceChannel();
